// extracted by mini-css-extract-plugin
export default {"container":"DiefCfem_container__L-vTP","textContainer":"DiefCfem_textContainer__J6wUA","errorMessage":"DiefCfem_errorMessage__CLVqz","button":"DiefCfem_button__6d2zP"};